import _ from "lodash";
import * as classroomApi from "@/js/api/classroomApi";
import iconWindowsDevice from "@/assets/IconWindowsDevice.svg?url";

export interface SignaturesResponse {
	signatures: SignatureData[];
	appControls: AppControlData[];
}

export interface SignatureData {
	category: null | string;
	dependencies: string[];
	description: string;
	enabled: boolean;
	favicon_url: null | string;
	focus: boolean;
	hidden: boolean;
	id: string;
	is_category: boolean;
	is_high_level_signature: boolean;
	is_low_level_signature: boolean;
	is_sub_category: boolean;
	name: string;
	noise: boolean;
	reporting: boolean;
	tags: string[];
	url: null | string;
}

export interface AppControlData {
	id: string;
	name: string;
	favicon: string;
	platforms: Array<"windows">; // element will be a union type when more platforms are added
}

export async function getSignatures(): Promise<SignaturesResponse> {
	// `classroomApi.Get2` swallows errors and returns `null` cast to its generic; treat it as possibly absent.
	const res = (await classroomApi.Get2("v1/signatures")) as SignaturesResponse | null | undefined;
	const signatures = res?.signatures ?? [];
	const appControls = res?.appControls ?? [];

	for (const appControl of appControls) {
		if (_.isEmpty(appControl.favicon)) {
			appControl.favicon = iconWindowsDevice;
		}
	}

	return { signatures, appControls };
}
